var map = {
	"./apple2e": [
		553,
		553
	],
	"./apple2e.ts": [
		553,
		553
	],
	"./apple2enh": [
		45,
		45
	],
	"./apple2enh.ts": [
		45,
		45
	],
	"./apple2ex": [
		875,
		875
	],
	"./apple2ex.ts": [
		875,
		875
	],
	"./apple2j": [
		156,
		156
	],
	"./apple2j.ts": [
		156,
		156
	],
	"./fpbasic": [
		94,
		94
	],
	"./fpbasic.ts": [
		94,
		94
	],
	"./intbasic": [
		89,
		89
	],
	"./intbasic.ts": [
		89,
		89
	],
	"./original": [
		663,
		663
	],
	"./original.ts": [
		663,
		663
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 190;
module.exports = webpackAsyncContext;